// hooks/useNotificationChannelSync.ts
import { useEffect, useMemo } from 'react';
import { useDispatchApp } from 'redux/rootSelectors';
import { setNotificationMessages } from 'domains/notification/reducer';
import { genFetchedData } from 'redux/fetchedData';

export const useNotificationChannelSync = (): void => {
  const dispatch = useDispatchApp();

  const notificationChannel = useMemo(
    () => new BroadcastChannel('notification_channel'),
    [],
  );

  useEffect(() => {
    notificationChannel.onmessage = (event) => {
      if (event.data.type === 'NOTIFICATIONS_UPDATED') {

        const updatedData = genFetchedData(event.data.payload)
          .set('data', event.data.payload)
          .set('isLoading', false);

        dispatch(setNotificationMessages(updatedData));
      }
    };

    return () => {
      notificationChannel.close();
    };
  }, [notificationChannel, dispatch]);
};
